module.exports = __webpack_public_path__ + "assets/img/svg/logos/logo-for-video-blur.svg?v=1755677078523";